import { ethers } from 'ethers'
import { createAppKit } from '@reown/appkit'
import { Ethers5Adapter } from '@reown/appkit-adapter-ethers5'
import { mainnet, bsc } from '@reown/appkit/networks'

const projectId = '0e30ec6ea2fd5335979d5fd96f8df599' // https://cloud.reown.com 免费注册获取

const modal = createAppKit({
  adapters: [new Ethers5Adapter()],
  projectId,
  networks: [bsc, mainnet],
  defaultNetwork: bsc,
  metadata: {
    name: 'bscpool',
    description: 'bscpool',
    url: window.location.origin,
    icons: []
  }
})

let _provider = null
let _account  = null

function hasInjected() {
  return typeof window !== 'undefined' && !!window.ethereum
}

export async function connectWallet() {
 
  if (hasInjected()) {
    _provider = new ethers.providers.Web3Provider(window.ethereum, 'any')
    const accounts = await _provider.send('eth_requestAccounts', [])
    _account = accounts[0]

    window.ethereum.on('accountsChanged', (accs) => {
      _account = accs[0] || null
      _provider = new ethers.providers.Web3Provider(window.ethereum, 'any')
    })
    window.ethereum.on('chainChanged', () => {
      _provider = new ethers.providers.Web3Provider(window.ethereum, 'any')
    })

    return _account
  }

  await modal.open()

  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      unsub()
      reject(new Error('连接超时，请重试'))
    }, 120000)

    const unsub = modal.subscribeAccount(async (state) => {
      if (state.status === 'connected' && state.address) {
        clearTimeout(timer)
        unsub()
        _account = state.address
        try {
          const wp = modal.getWalletProvider()
          _provider = new ethers.providers.Web3Provider(wp)
          resolve(_account)
        } catch (e) {
          reject(e)
        }
      }
    })
  })
}

export async function disconnectWallet() {
  if (!hasInjected()) {
    try { await modal.disconnect() } catch (_) {}
  }
  _provider = null
  _account  = null
}

export function getAccount() { return _account }
export function getProvider() { return _provider }
/**
 * 获取当前链 ID
 * @returns {Promise<string>} 链 ID，如 "0x38"（BSC）、"0x1"（ETH）
 */
export async function getChainId() {
  const provider = getProvider()
  if (!provider) throw new Error('请先连接钱包')
  const network = await provider.getNetwork()
  return network.chainId  // 返回数字，如 56（BSC）、1（ETH）
}

/**
 * 获取当前 Gas Price
 * @returns {Promise<{wei: BigNumber, gwei: string}>}
 */
export async function getGasPrice() {
  const provider = getProvider()
  if (!provider) throw new Error('请先连接钱包')
  const gasPrice = await provider.getGasPrice()
  return {
    wei: gasPrice,                                              // BigNumber 原始值
    gwei: ethers.utils.formatUnits(gasPrice, 'gwei')           // 可读的 Gwei 字符串
  }
}